import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.5.1_d229e40015be0471a0521c4a5e460bd9/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/apps/web/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}